<template>
    <div class="login-container">
      <div class="login-box">
          <div class="login-title">欢迎登录</div>
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login-form">
            <el-form-item label="公司编码" prop="csn">
              <el-input v-model="loginForm.csn" placeholder="请输入公司编码" prefix-icon="el-icon-user" />
            </el-form-item>
               <el-form-item label="账号" prop="username">
                  <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user" />
              </el-form-item>
              <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-thumb" />
              </el-form-item>
                <el-form-item>
                      <el-button type="primary" @click="login()">登录</el-button>
                      <el-button type="info" @click="resetLoginForm">重置</el-button>
                </el-form-item>
          </el-form>
      </div>
    </div>
</template>

<script>
import { hexMD5 } from '../utils/md5' //引入
export default {
  name: "LoginView",
  data() {
    return {
      loginForm: {
        csn:"BS0001",
        username: null,
         password: null,
      },
      objArr:{},
      loginFormRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 15,
          //   message: "长度在 6 到 15 个字符",
          //   trigger: "blur",
          // },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 15,
          //   message: "长度在 6 到 15 个字符",
          //   trigger: "blur",
          // },
        ],
      },

    };
  },
  created(){
  },
  mounted() {

  },
  methods: {

    //重置按钮
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },
    //登录按钮
    login() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          console.log(this.loginForm,99);
          let obj = {
						username: this.loginForm.username,
						password: hexMD5(this.loginForm.password),
						csn: this.loginForm.csn,
						appid:'20220101'
					}
          this.objArr = obj;
					obj.sign=this.sign(this.objArr);
          this.$axios.getShopUserLogin(this.objArr).then(res=>{
            if (res.code == 200) {
                console.log('login rs-----',res)
                this.$message.success('登录成功');
                sessionStorage.setItem("csn", this.loginForm.csn);
                sessionStorage.setItem("token", res.data.token);
                sessionStorage.setItem("extract_shop_id", res.data.extract_shop_id);
                sessionStorage.setItem("extract_clerk_id", res.data.extract_clerk_id);
                sessionStorage.setItem("shop_id",res.data.shop_id);
                sessionStorage.setItem("proxy_id",res.data.proxy_id);
                console.log('shop',res.data.shop)
                sessionStorage.setItem("shop", JSON.stringify(res.data.shop));
                sessionStorage.setItem("remark", res.data.remark);
                sessionStorage.setItem('company_id', res.data.company_id);
                sessionStorage.setItem('employee_id', res.data.employee_id);
                sessionStorage.setItem('creator_id', res.data.employee_id);

                sessionStorage.setItem('creator_name', res.data.employee? res.data.employee.name_cn:'');

                sessionStorage.setItem('user_id', res.data.id);
                sessionStorage.setItem('uid', res.data.id);
                // window.localStorage.setItem("menu", res.data.menu);
                window.sessionStorage.setItem("userName", res.data.user_name);
                sessionStorage.setItem("company_role_id", res.data.company_role_id);
                sessionStorage.setItem("roles", JSON.stringify(res.data.roles));
                this.$router.replace("/home");
              } else {
                this.$message.error(res.msg);
              }
          }).catch(error=>{
            console.log(error);
          })
        }
      });
    },
    sign(unordered){
                const secret="37506178be498bf490e2e25b8f5ccb4d";
				const ordered = {};
				Object.keys(unordered).sort().forEach(function(key) {
					if(!Array.isArray(unordered[key])){
					ordered[key] = unordered[key];
					}
				});
				var rs="";
				for(var m in ordered ){
					rs +=m+"="+ordered[m]+"&";
				}

				return hexMD5(hexMD5(rs+"key="+secret)).toLocaleUpperCase();

			},

  },
};
</script>

<style lang="less" scoped>

.login-container{
    height: 100vh;
    background: url('../assets/upload/login_bg.jpg') no-repeat center center;
    background-size: cover;
}
.login-box {
    position: absolute;
    top: 40%;
    right: 10%;
    transform: translate(-10%, -40%);
    width: 420px;
    background-color: #fff;
    border: 1px solid #DCDFE6;
    border-radius: 8px;
    padding: 20px;
    // box-shadow: 0 0 20px #999;
    .login-title {
      text-align: center;
      font-size: 24px;
    }
  }

</style>
